import React, {Component} from 'react';
import './App.scss';
import {BrowserRouter as Router} from "react-router-dom";
import {Provider} from "react-redux";
import {configureStore} from "./RootReducer";
import LoginForm from "./login/LoginForm";
import LoggedInContent from "./ui/LoggedInContent";


class App extends Component {

    render() {
        return (
            <Provider store={configureStore()}>
                <Router>
                    <LoginForm />
                    <LoggedInContent />
                </Router>
            </Provider>
        );
  }
}

export default App;

